export const initFacetReveal = () => {
    const facetSettingsButton = document.querySelector('.js-facet-settings');
    const facets = document.querySelector('.product-filters__facets');
    function toggleFacetsVisibility() {
        facets.classList.toggle('visible');
    }

    if  (facetSettingsButton){
        facetSettingsButton.addEventListener('click', toggleFacetsVisibility);
    }
};